import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    CircularProgress,
    withRouter
} from '../../material-ui';

import AppUtils from '../../control/apputlis';
import DeviceEventEmitter from '../../control/event';
import Apis from '../../network/Apis';
import AppData from '../../model/AppData';
import AppConfig from '../../control/config';

class PlayRoom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'PlayRoom');
        console.log('进入直播间')
        DeviceEventEmitter.on('LoginSuccess', this.isJumptoRoom, this);
        if (!AppData.me.isLogin() && AppData.os == '' && !AppData.me.isYk && !AppData.me.isYkLogin()) {
            AppData.login();
        } else {
            console.log('已经登录了，直接跳入房间');
            this.isJumptoRoom()
        }
    }

    componentWillUnmount() {
        this.setState = () => false;
        DeviceEventEmitter.off('LoginSuccess', this.isJumptoRoom, this);
    }

    //是否跳进直播间
    isJumptoRoom = async () => {
        console.log("收到登录完成");
        let { match_type, match_id } = this.props.match.params;
        if (match_type && match_id) {
            let res = await Apis.encryptionJumpToRoom(match_type, match_id);
            console.log('=====>直播间', res);
            if (res.code == 200 && res.data && res.data != 0) {
                let data = {
                    room_id: res.data,
                    match_type, match_id
                }
                this.jumpToRoom(data)
            } else {
                this.jumpToHome();
            }
        } else {
            this.jumpToHome();
        }
    }


    jumpToHome = () => {
        this.props.history.push('/');
    }

    jumpToRoom = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;

        let os = 'h5';
        if (AppData.os !== '') {
            os = AppData.os
        }
        let token = '0';

        if (AppData.me.token !== '') {
            token = AppData.me.token
        }

        let customerId = 0
        if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
            customerId = AppData.me.customer_id
        }
        let uid = AppUtils.getStorageItem('uid');
        let fastkey = AppUtils.getStorageItem("fastkey");
        let roomIp = AppUtils.getStorageItem("roomIp");
        let roomPort = AppUtils.getStorageItem("roomPort");
        let channel = AppUtils.getStorageItem("channel");
        if (!channel) {
            channel = AppConfig.channelid
        }

        let fid = AppData.me.free_id
        this.props.history.replace({ pathname: `/play/${room_id}/${match_type}/${match_id}/${uid}/${fastkey}/${roomIp}/${roomPort}/${os}/${token}/${customerId}/${fid}/${channel}`, data: data });

    }

    render() {
        const { classes } = this.props
        return (<Grid container direction='column' justifyContent='center' className={classes.root}>
            <CircularProgress size={20} />
            <Typography className={classes.tipText}>正在进入房间,请稍后...</Typography>
        </Grid>);
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center'
    },
    tipText: {
        fontSize: 15,
        color: '#0D0D0D',
        marginTop: 16
    }
}))(PlayRoom));